import { useEffect } from "react"
import { EEGMontage } from "../Types/EEG"
import { eegMontagesAtom } from "../Atoms/EEGMontage"
import { useRecoilValue } from "recoil"
import { getValidatedMontage } from "../Utils/eegWindowMontage"

type useValidateEEGMontageProps = {
    montage: EEGMontage | null
    updateMontage: (montage: EEGMontage | null) => void
	defaultMontageId?: number
}

export const useValidateEEGMontage = ({ montage, updateMontage, defaultMontageId=1 }: useValidateEEGMontageProps) => {
    const eegMontages = useRecoilValue(eegMontagesAtom)

    // Check to see if the montage still exists in the database, or if any properties changed.
    // If a valid EEG montage exists, use the updated properties. If not, use a default. If there are no defaults, use null.
	useEffect(() => {
		const newMontage = getValidatedMontage(montage, eegMontages, defaultMontageId)

		if (newMontage !== undefined) {
			updateMontage(newMontage)
		}
	}, [defaultMontageId, eegMontages, montage, updateMontage])
}
